import { useMutation } from '@apollo/client'
import { AdminAPI, GraphQL } from '@guestgoodie/graphql'
import { Delete01Icon } from '@hugeicons/core-solid-rounded'
import { Trans, useLingui } from '@lingui/react/macro'

import Button from '@/components/ui/Button'
import ConfirmDialog from '@/components/ui/ConfirmDialog'
import Loading from '@/components/ui/Loading'

export function ConnectedView({ pms }: { pms: GraphQL.PmsFragmentFragment }) {
  const { t } = useLingui()

  const isSyncingStays = pms.syncing?.includes(GraphQL.SyncableObject.Stays)
  const isSyncingRooms = pms.syncing?.includes(GraphQL.SyncableObject.Rooms)
  const provider = pms.provider

  const [remove, { loading }] = useMutation(AdminAPI.pms.REMOVE, {
    refetchQueries: [AdminAPI.pms.GET]
  })

  return (
    <div className="flex flex-col gap-5 p-2.5">
      <div className="flex flex-col gap-2.5 p-2.5">
        <h2 className="text-text text-heading2">
          <Trans>Your PMS is connected and working.</Trans>
        </h2>
        <p className="text-text text-regular">
          <Trans>Currently connected with PMS: {provider}</Trans>
        </p>
        {isSyncingRooms && (
          <div className="flex flex-row items-center gap-2">
            <Loading />
            <span className="text-regular text-text">
              <Trans>Currently syncing Rooms</Trans>
            </span>
          </div>
        )}
        {isSyncingStays && (
          <div className="flex flex-row items-center gap-2">
            <Loading />
            <span className="text-regular text-text">
              <Trans>Currently syncing Reservations</Trans>
            </span>
          </div>
        )}
      </div>
      <div className="flex flex-row justify-between gap-2">
        <ConfirmDialog
          title={t`Disconnect PMS?`}
          message={t`Are you sure that you want to disconnect your PMS "${provider}"? You will keep all data, but you cannot sync guests, stays and rooms anymore.`}
          onConfirm={remove}
          asChild
        >
          <Button
            loading={loading}
            type="button"
            variant="outline"
            Icon={Delete01Icon}
          >
            <Trans>Disconnect PMS</Trans>
          </Button>
        </ConfirmDialog>
      </div>
    </div>
  )
}
